import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b473843e20d44a3d88e3781b3f85789c@o455581.ingest.sentry.io/6381598",
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
});
